import { FC } from "react";
import { Box, Typography } from "@mui/material";
import { DataGrid } from "../../../../components/datagrid";
import { useCompletedCounterpartyColumns } from "./hooks/useCompletedCounterpartyColumns";
import { useCompletedCounterpartyOverview } from "../../dataHooks/counterpartyQueries";
import { useRoles } from "../../../../auth/useRoles";
import {
  hasAnyAppRole,
  isGlobalLifecycleRole
} from "../../../../auth/permissions";

type Props = {};

export const CompletedCounterpartiesGrid: FC<Props> = () => {
  const { data, isLoading, isFetching } = useCompletedCounterpartyOverview();

  const rows = data || [];
  const roles = useRoles();
  const columns = useCompletedCounterpartyColumns(
    rows,
    isGlobalLifecycleRole(roles)
  );
  const showGrantModeEmptyState =
    !isLoading && !isFetching && rows.length === 0 && !hasAnyAppRole(roles);

  if (showGrantModeEmptyState) {
    return (
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center"
        }}
      >
        <Typography variant="h6">
          You do not have access to any completed counterparties yet.
        </Typography>
      </Box>
    );
  }

  return (
    <DataGrid
      loading={isLoading || isFetching}
      columns={columns}
      rows={rows}
      getRowId={(row) => row.id}
      getRowHref={(row) =>
        `/tradingcounterparties/counterparty/${row.id}`
      }
      searchPlaceholder="Search completed counterparties"
      exportFileName="Completed counterparties"
      initialState={{
        sorting: {
          sortModel: [
            {
              field: "signOffCompletedAt",
              sort: "desc"
            }
          ]
        }
      }}
      sx={{
        "&.MuiDataGrid-root .MuiDataGrid-cell:focus": {
          outline: "none"
        }
      }}
    />
  );
};
